import React from 'react';
import {ComplaintDetailContent} from './sub-view/complaint-detail-content';
import {UserLayout} from 'components/layouts/user';

class ComplaintDetailContainer extends React.Component {
  constructor(props, context) {
    super(props, context);
  }

  render() {
    return (
      <UserLayout>
        <h1 className="user-header">Chi tiết khiếu nại</h1>
        <ComplaintDetailContent/>
      </UserLayout>
    );
  }
}

export default ComplaintDetailContainer;



// WEBPACK FOOTER //
// ./components/users/ComplaintDetailContainer.jsx